/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waiting_On_Credit_ControlInputs */

const en_waiting_on_credit_control = /** @type {(inputs: Waiting_On_Credit_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting on Credit Control`)
};

/**
* | output |
* | --- |
* | "Waiting on Credit Control" |
*
* @param {Waiting_On_Credit_ControlInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const waiting_on_credit_control = /** @type {((inputs?: Waiting_On_Credit_ControlInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waiting_On_Credit_ControlInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_waiting_on_credit_control(inputs)
});